import { useMutation } from '@tanstack/react-query'
import { apiDelete, apiPostVoid } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

// Организатор глушит участника — состояние прилетит через SFU, ответ пустой.
export function useMuteParticipant(meetingId: string) {
  return useMutation({
    mutationFn: (participantId: string) =>
      apiPostVoid(`/meetings/${meetingId}/participants/${participantId}/mute`),
    onError: () => toast.error('Не удалось заглушить участника'),
  })
}

// Организатор выгоняет участника.
export function useKickParticipant(meetingId: string) {
  return useMutation({
    mutationFn: (participantId: string) =>
      apiDelete(`/meetings/${meetingId}/participants/${participantId}`),
    onSuccess: () => toast.success('Участник удалён из встречи'),
    onError: () => toast.error('Не удалось выгнать участника'),
  })
}
